import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  nameText: {
    width: "30%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  emailText: {
    width: "30%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "flex",
      alignItems: "baseline",
    },
  },
  switch: {
    width: "10%",
    [theme.breakpoints.down("sm")]: {
      width: "30%",
    },
  },
  labelSpan: {
    color: "#092958",
    fontSize: "0.75rem",
    fontFamily: "Roboto,sans-serif",
    fontWeight: 700,
    lineHeight: 1.57,
    letterSpacing: "0.00714em",
  },
  statusText: {
    width: "10%",
    [theme.breakpoints.down("sm")]: {
      width: "30%",
      alignItems: "baseline",
      display: "flex",
    },
  },
  button: {
    width: "20%",
    [theme.breakpoints.down("sm")]: {
      width: "30%",
    },
  },
}))

export default styles
